<template>
  <div class="flex gap-3 items-center" data-testid="person-avatar-group">
    <div
      :class="['flex', direction === 'horizontal' ? 'flex-row -space-x-1' : 'flex-col -space-y-1']"
      data-testid="person-avatar-group-container"
    >
      <VTooltip
        v-for="(person, index) in visibleItems"
        :key="index"
        :text="`${person.firstName} ${person.lastName}`"
        location="top"
        data-testid="person-avatar-tooltip"
      >
        <template #activator="{ props: tooltipProps }">
          <PersonAvatar
            v-bind="tooltipProps"
            :first-name="person.firstName"
            :last-name="person.lastName"
            :type="person.type"
            :size="size"
            class="ring-2 ring-white"
            data-testid="person-avatar-visible"
          />
        </template>
      </VTooltip>

      <VMenu
        v-if="hiddenItemsCount > 0"
        open-on-click
        location="bottom"
        data-testid="hidden-items-menu"
      >
        <template #activator="{ props: menuProps }">
          <VAvatar
            v-bind="menuProps"
            :size="size"
            color="gray-100"
            class="cursor-pointer border border-gray-200 ring-2 ring-white"
            data-testid="hidden-items-avatar"
          >
            <span class="font-semibold text-gray-500" data-testid="hidden-items-count">
              +{{ hiddenItemsCount }}
            </span>
          </VAvatar>
        </template>

        <VList data-testid="hidden-items-list">
          <VListItem
            v-for="(item, index) in items"
            :key="index"
            class="px-5 py-1 hover:bg-gray-200 [--v-list-prepend-gap:8px]"
            data-testid="hidden-item-list-item"
          >
            <template #prepend>
              <PersonAvatar
                :first-name="item.firstName"
                :last-name="item.lastName"
                :type="item.type"
                :size="32"
                data-testid="hidden-item-avatar"
              />
            </template>
            <VListItemTitle
              class="text-sm text-gray-900 font-semibold"
              data-testid="hidden-item-title"
            >
              {{ item.firstName }} {{ item.lastName }}
            </VListItemTitle>
          </VListItem>
        </VList>
      </VMenu>
    </div>
  </div>
</template>

<script setup lang="ts">
import PersonAvatar, { type PersonAvatarProps } from '@/components/navigation/PersonAvatar.vue'
import { computed } from 'vue'

interface Props {
  items: PersonAvatarProps[]
  direction?: 'horizontal' | 'vertical'
  max?: number
  size?: number
}

const props = withDefaults(defineProps<Props>(), {
  max: 4,
  direction: 'horizontal',
  size: 24
})

const visibleItems = computed(() => {
  return props.items.slice(0, props.max)
})

const hiddenItemsCount = computed(() => {
  return Math.max(0, props.items.length - props.max)
})
</script>
